import client from './client';

export async function login(email, password) {
  const { data } = await client.post('/auth/login', { email, password });
  return data.data; // { token, user }
}

export async function logout() {
  await client.post('/auth/logout');
}

export async function fetchMe() {
  const { data } = await client.get('/auth/me');
  return data.data; // user with roles + permissions
}

export async function updateProfile(payload) {
  const { data } = await client.put('/auth/profile', payload);
  return data.data;
}
